<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">AVAILABLE COURSES</h4>
                
            </div>
        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Type Of Course</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Enroll</th>
                        </tr>
                    </thead>


                    <tbody>
                        <tr *ngFor="let coursedata of values">
                            <td style="min-width: 20px;">
                                {{coursedata.course_name}}
                            </td>

                           
                            <td style="min-width: 20px;">
                                {{coursedata.course_des

                                }}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.typeofcourse
                                }}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.course_date
                                | date: 'dd-MM-yyyy'}}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.course_time
                                }}
                            </td>
                            <td>
                                <ng-container *ngIf="isCourseCompleted(coursedata.course_date); else enrollButton">
                                    <button class="btn btn-secondary btn-circle btn-sm course-button" disabled>Completed</button>
                                  </ng-container>
                                  <ng-template #enrollButton>
                                    <a data-toggle="modal" data-target="#myModal1" class="btn btn-primary btn-circle btn-sm course-button" (click)="enroll(coursedata)">Enroll</a>
                                  </ng-template>
                                  
                                  

                                <!-- <a data-toggle="modal" data-target="#myModal1" class="btn btn-primary btn-circle btn-sm" (click)="enroll(coursedata)">Enroll
                                  </a> -->
                                <!-- <ng-container *ngIf="coursedata.typeofcourse == 'Technical'; else motivationalBlock">
                                  <a data-toggle="modal" data-target="#myModal" class="btn btn-primary btn-circle btn-sm" (click)="get_coursebyid(coursedata.id,'UPDATE')">
                                    <i class="fas fa-check"></i>
                                  </a>
                                </ng-container>
                                <ng-template #motivationalBlock>
                                  <a data-toggle="modal" data-target="#myModal1" class="btn btn-primary btn-circle btn-sm" (click)="get_coursebyid(coursedata.id,'UPDATE')">
                                    <i class="fas fa-check"></i>
                                  </a>
                                </ng-template> -->
                              </td>
                            
                            
                          
                        </tr>
                    </tbody>
                </table>


                
            </div>
        </div>

        
       